import React from "react";

import defaqtoStyles from "@/utils/defaqto-brand-colors.utils";

type DefaqtoProps = {
  stars: 1 | 2 | 3 | 4 | 5;
};

function Defaqto({ stars = 1 }: Readonly<DefaqtoProps>) {
  const width = 161 - 18.26 * (5 - stars);
  return (
    <svg
      data-testid="defaqto-test-id"
      style={{ marginLeft: "6px" }}
      width={width}
      height="16"
      viewBox={`0 0 ${width} 16`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00619 0.900391H7.94206V5.33752H7.91013C6.99853 4.0117 5.54776 3.67271 4.62019 3.67271C1.85523 3.67271 0.078125 5.82915 0.078125 8.07967C0.078125 10.4988 1.96341 12.5186 4.62019 12.5186C5.51584 12.5186 7.01449 12.1813 7.91013 10.8396H7.94206V12.2594H9.00619V0.900391ZM1.07486 8.05304C1.07486 5.90547 2.68347 4.56191 4.54393 4.56191C6.49484 4.56191 7.93497 6.18235 7.93497 8.03707C7.93497 10.0143 6.37246 11.4821 4.54393 11.4821C2.4671 11.4838 1.07486 9.93793 1.07486 8.05304Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4076 8.35556C19.4537 7.53913 19.3296 6.59668 18.7567 5.68441C18.1537 4.63547 16.8377 3.53861 14.9808 3.52441C12.5209 3.57234 10.5859 5.57792 10.5859 7.97042C10.5859 10.4712 12.6291 12.3845 14.995 12.3845C16.9459 12.3845 18.5705 11.1048 19.1575 9.42047H18.0118C17.6252 10.4712 16.5256 11.3817 14.979 11.4136C13.3225 11.4136 11.776 10.0079 11.698 8.35556H19.4076ZM11.698 7.46813C12.0066 5.47498 13.6648 4.58045 14.995 4.58045C16.3429 4.58045 17.9692 5.47675 18.3098 7.46813H11.698Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        d="M21.6009 12.2603H22.665V4.80591H24.9706V3.91848H22.782C22.782 3.19967 22.7519 1.9342 24.9706 1.9342V1.0166C21.8119 1.045 21.7179 2.84647 21.6878 3.91671H20.3594V4.80414H21.6009V12.2603Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.5427 3.74028H33.4786V5.33765H33.4484C32.5475 3.92664 31.0577 3.63379 30.139 3.63379C27.3581 3.63379 25.5703 5.80266 25.5703 8.06559C25.5703 10.4989 27.4662 12.5276 30.139 12.5276C31.024 12.5276 32.5155 12.2329 33.4484 10.8397H33.4786V12.2596H34.5427V3.74028ZM26.6522 8.05317C26.6522 5.9056 28.2626 4.56204 30.1212 4.56204C32.0722 4.56204 33.5123 6.18248 33.5123 8.0372C33.5123 10.0144 31.9498 11.4822 30.1212 11.4822C28.0462 11.484 26.6522 9.93806 26.6522 8.05317Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.0097 3.91777H43.9456V5.33765H43.9136C43.0127 3.94439 41.5211 3.63379 40.6042 3.63379C37.825 3.63379 36.0391 5.80266 36.0391 8.06559C36.0391 10.4989 37.9332 12.5276 40.6042 12.5276C41.4892 12.5276 42.9949 12.2329 43.9136 10.8397H43.9456V15.2768H45.0097V3.91777ZM37.1546 8.05317C37.1546 5.9056 38.765 4.56204 40.6219 4.56204C42.5728 4.56204 44.0147 6.18248 44.0147 8.0372C44.0147 10.0144 42.4487 11.4822 40.6219 11.4822C38.5486 11.484 37.1546 9.93806 37.1546 8.05317Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        d="M48.0236 12.2602H49.265V4.80579H51.2159V3.74088H49.265V0.723633H48.0236V3.74088H46.25V4.80579H48.0236V12.2602Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.9531 8.08554C51.9531 10.3733 53.8881 12.457 56.3657 12.457C58.9055 12.457 60.8103 10.3272 60.8103 8.02342C60.8103 5.70547 58.8735 3.58984 56.3657 3.58984C54.1364 3.58984 51.9531 5.41262 51.9531 8.08554ZM53.0368 8.06779C53.0368 5.82971 54.8316 4.56246 56.3799 4.56246C57.836 4.56246 59.7266 5.75161 59.7266 7.97728C59.7266 10.187 58.0222 11.4844 56.3799 11.4844C54.6312 11.4844 53.0368 10.0326 53.0368 8.06779Z"
        fill={defaqtoStyles.textColor}
      />
      <path
        data-testid="star-test-id"
        d="M76.8307 0.368164L78.7249 6.19855H84.8507L79.8954 9.8015L81.7878 15.6319L76.8307 12.0289L71.8754 15.6319L73.7696 9.8015L68.8125 6.19855H74.9383L76.8307 0.368164Z"
        fill="#EE7203"
      />
      {stars !== 1 && (
        <>
          <path
            data-testid="star-test-id"
            d="M95.8698 0.368164L97.7622 6.19855H103.888L98.9327 9.8015L100.825 15.6319L95.8698 12.0289L90.9145 15.6319L92.8069 9.8015L87.8516 6.19855H93.9774L95.8698 0.368164Z"
            fill="#EE7203"
          />
          {stars !== 2 && (
            <>
              <path
                data-testid="star-test-id"
                d="M114.909 0.368164L116.803 6.19855H122.927L117.972 9.8015L119.866 15.6319L114.909 12.0289L109.954 15.6319L111.846 9.8015L106.891 6.19855H113.016L114.909 0.368164Z"
                fill="#EE7203"
              />

              {stars !== 3 && (
                <>
                  <path
                    data-testid="star-test-id"
                    d="M133.94 0.368164L135.834 6.19855H141.958L137.003 9.8015L138.897 15.6319L133.94 12.0289L128.985 15.6319L130.877 9.8015L125.922 6.19855H132.048L133.94 0.368164Z"
                    fill="#EE7203"
                  />
                  {stars !== 4 && (
                    <path
                      data-testid="star-test-id"
                      d="M152.979 0.368164L154.873 6.19855H160.997L156.042 9.8015L157.936 15.6319L152.979 12.0289L148.024 15.6319L149.916 9.8015L144.961 6.19855H151.087L152.979 0.368164Z"
                      fill="#EE7203"
                    />
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </svg>
  );
}

export default Defaqto;
